import { Component, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { PayService } from 'src/app/service/pay.service';
import { Router } from '@angular/router';

interface AccountRow {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  typ: number;
  typb: number;
  secure: boolean;
  confirmCNi: boolean;
  confirmphone: boolean;
  hasPrimaryAccount: boolean;
  hasBusinessAccount: boolean;
}

@Component({
  selector: 'app-primary-account',
  templateUrl: './primary-account.component.html',
  styleUrls: ['./primary-account.component.css'],
  standalone: false
})
export class PrimaryAccountComponent implements OnInit {
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  persons: AccountRow[] = [];
  nom: any;
  prenom: any;
  gestionaireList: any[];
  userid: any;
  gestionaireid: any;
  gestionaire = "";
  hasAssignedGestionaire = false;
  isAssigningGestionaire = false;
  gestionaireFeedbackMessage = "";
  gestionaireFeedbackType: 'success' | 'error' | '' = '';

  constructor(private userService: PayService, private router: Router) { }

  ngOnInit(): void {
    $('#utilisateur').DataTable().init;
    this.findallPrimaryAccount();
    this.findPartenaires();
  }

  findallPrimaryAccount() {
    if ($.fn.DataTable.isDataTable('#utilisateur')) {
      $('#utilisateur').DataTable().destroy();
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    forkJoin({
      primary: this.userService.getprimaryAccounts(),
      business: this.userService.getBussnessAcounts()
    }).subscribe({
      next: (sources: any) => {
        this.persons = this.mergeAccountLists(sources.primary, sources.business);
        this.dtTrigger.next();
      },
      error: () => {
        this.persons = [];
      }
    });
  }

  private mergeAccountLists(primaryUsers: any[], businessUsers: any[]): AccountRow[] {
    const merged = new Map<number, AccountRow>();

    (Array.isArray(primaryUsers) ? primaryUsers : [])
      .forEach((user: any) => this.upsertAccountRow(merged, user, 'primary'));
    (Array.isArray(businessUsers) ? businessUsers : [])
      .forEach((user: any) => this.upsertAccountRow(merged, user, 'business'));

    return Array.from(merged.values()).sort((left, right) => left.id - right.id);
  }

  private upsertAccountRow(
    merged: Map<number, AccountRow>,
    user: any,
    source: 'primary' | 'business'
  ): void {
    const userId = Number(user.id);
    const hasBusinessAccount = source === 'business' || Number(user.typ) === 2;
    const accountRow = merged.get(userId);

    if (accountRow == null) {
      merged.set(userId, {
        id: userId,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        phone: user.phone,
        typ: Number(user.typ),
        typb: Number(user.typb),
        secure: !!user.secure,
        confirmCNi: !!user.confirmCNi,
        confirmphone: !!user.confirmphone,
        hasPrimaryAccount: true,
        hasBusinessAccount: hasBusinessAccount
      });
      return;
    }

    accountRow.firstName = user.firstName || accountRow.firstName;
    accountRow.lastName = user.lastName || accountRow.lastName;
    accountRow.email = user.email || accountRow.email;
    accountRow.phone = user.phone || accountRow.phone;
    accountRow.typ = user.typ == null ? accountRow.typ : Number(user.typ);
    accountRow.typb = user.typb == null ? accountRow.typb : Number(user.typb);
    accountRow.secure = !!user.secure;
    accountRow.confirmCNi = !!user.confirmCNi;
    accountRow.confirmphone = !!user.confirmphone;
    accountRow.hasBusinessAccount = accountRow.hasBusinessAccount || hasBusinessAccount;
  }

  getAccountInformation(id, firstaname, lastname) {

    this.router.navigateByUrl("utilisateur/admin/compte/primaire/information/" + id)
  }

  getBusinessAccountInformation(id, firstaname, lastname) {
    this.router.navigateByUrl("utilisarteur/admin/compte/affaire/information/" + id)
  }

  initModalGestionnaire(id, firstaname, lastname) {
    this.gestionaire = "";
    this.gestionaireid = null;
    this.hasAssignedGestionaire = false;
    this.gestionaireFeedbackMessage = "";
    this.gestionaireFeedbackType = '';
    this.nom = lastname;
    this.prenom = firstaname;
    this.userid = id;
    this.userService.findGestionaire(id).subscribe(data => {
      if (data != null) {
        const fullName = `${data['lastName'] ?? ''} ${data['firstName'] ?? ''}`.trim();
        this.gestionaire = fullName;
        this.hasAssignedGestionaire = fullName.length > 0;
      }
      //console.log(data);
    })
  }

  findPartenaires() {
    this.userService.afficherGestionaires().subscribe((data: any[]) => {
      this.gestionaireList = data;

    })
  }

  gestionaireIdSave(id) {
    this.gestionaireid = id;
    this.gestionaireFeedbackMessage = "";
    this.gestionaireFeedbackType = '';

  }

  addGestionaire() {
    if (!this.gestionaireid) {
      this.gestionaireFeedbackType = 'error';
      this.gestionaireFeedbackMessage = "Veuillez selectionner un gestionaire.";
      return;
    }

    this.isAssigningGestionaire = true;
    this.gestionaireFeedbackMessage = "";
    this.gestionaireFeedbackType = '';

    this.userService.utilisateurAddGestionaire(this.userid, this.gestionaireid).subscribe({
      next: () => {
        this.isAssigningGestionaire = false;
        const selected = (this.gestionaireList || []).find((g: any) => String(g.id) === String(this.gestionaireid));
        if (selected != null) {
          this.gestionaire = `${selected.lastName ?? ''} ${selected.firstName ?? ''}`.trim();
        }
        this.hasAssignedGestionaire = this.gestionaire.length > 0;
        this.gestionaireFeedbackType = 'success';
        this.gestionaireFeedbackMessage = "Gestionaire attribue avec succes.";
        this.findallPrimaryAccount();
      },
      error: (error) => {
        this.isAssigningGestionaire = false;
        const errorMessage = error?.error?.message || error?.message;
        this.gestionaireFeedbackType = 'error';
        this.gestionaireFeedbackMessage = errorMessage
          ? `Echec de l'attribution: ${errorMessage}`
          : "Impossible d'attribuer le gestionaire.";
      }
    });
  }

  UpdateUserPassword(id) {
    this.userService.adminUpdateUserPassword(id).subscribe(data => {

    })
  }

  get totalUsers(): number {
    return this.persons?.length || 0;
  }

  get totalPrimaryUsers(): number {
    return (this.persons || []).filter(person => person.hasPrimaryAccount).length;
  }

  get totalBusinessUsers(): number {
    return (this.persons || []).filter(person => person.hasBusinessAccount).length;
  }

  get totalVerifiedUsers(): number {
    return (this.persons || []).filter(person => this.isIdentityVerified(person)).length;
  }

  isIdentityVerified(person: AccountRow): boolean {
    return !!person?.confirmCNi && !!person?.confirmphone;
  }

  getIdentityLabel(person: AccountRow): string {
    return this.isIdentityVerified(person) ? 'Verifie' : 'A verifier';
  }

  getIdentityClass(person: AccountRow): string {
    return this.isIdentityVerified(person) ? 'is-ok' : 'is-warning';
  }

  trackByPersonId(index: number, person: AccountRow): number {
    return person.id;
  }
}
